export class AESEncryptor {
    private keyPromise: Promise<CryptoKey>;

    constructor(password: string) {
        this.keyPromise = (async () => {
            const keyMaterial = await window.crypto.subtle.importKey(
                'raw',
                new TextEncoder().encode(password),
                'PBKDF2',
                false,
                ['deriveKey']
            );

            const key = await window.crypto.subtle.deriveKey(
                {
                    name: 'PBKDF2',
                    salt: new TextEncoder().encode('SalDoHimalaia'),
                    iterations: 4096,
                    hash: 'SHA-512',
                },
                keyMaterial,
                { name: 'AES-CBC', length: 256 },
                false,
                ['decrypt']
            );
            return key;
        })();
    }

    async decrypt(username: string, domain: string, encrypted: string, auth: any): Promise<void> {
        const key = await this.keyPromise;
        const raw = atob(encrypted);
        const ivBytes = new Uint8Array([...raw.slice(0, 16)].map(c => c.charCodeAt(0)));
        const dataBytes = new Uint8Array([...raw.slice(16)].map(c => c.charCodeAt(0)));

        const result = await window.crypto.subtle.decrypt(
            { name: 'AES-CBC', iv: ivBytes },
            key,
            dataBytes
        );

        const password = new TextDecoder().decode(result);
        auth.complete(username, domain, password);
        auth.delete();
    }
}
